The upper limit of items to return from the start of the list.

Defaults to 10 if `first` is not specified.
Excess items will be trimmed from the end of the list.
